import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { ReliabilityDocument } from '../domain/reliability';
import { fetchStorageJson } from '../services/firebaseStorage';

/** ADAC/TÜV reliability dataset, built by backend/src/reliability/build-reliability.js into `reliability/latest.json`. */
export function useReliability(): UseQueryResult<ReliabilityDocument> {
  return useQuery({
    queryKey: ['reliability'],
    queryFn: () => fetchStorageJson<ReliabilityDocument>('reliability/latest.json'),
    staleTime: 1000 * 60 * 60, // rebuilt at most weekly upstream
  });
}
